<mat-sidenav-container>
  <div id="board">
    <!--    {{board.name}}-->
    <div fxFlex class="board-content-wrapper">
      <div class="board-content ngx-dnd-container flex flex-row"
           ngxDroppable="list" [model]="activityFeeds" (out)="onDrop()"
           *fuseIfOnDom [@animateStagger]="{value:'50'}">
        <particle-activity-feed
          class="particle-activity-feed list-wrapper ngx-dnd-item"
          ngxDraggable
          [setFeedOnRightSidebar]="false"
          *ngFor="let feedInfo of activityFeeds; let i=index"
          [model]="feedInfo"
          [moves]="true"
          [feedInfo]="feedInfo"
          [feedContentId]="activityFeedContentId + i"
          [setFeedOnRightSidebar]="false"
          [handler]="handler"
          [isDraftFilter]="isOpenFilterEditView && feedInfo.isDefault"
          [filterSettings]="filterSettings"
          [conversationId]="conversationId"
          [messageId]="messageId"
          (dataToHeader$)="onFilterSettingChange($event, feedInfo)"
          (newFeedInfo$)="onAddNewFeed($event, i)"
          (feedIdToRemove$)="onRemoveActivityFeed($event, i)"
          [@animate]="{value:'*',params:{duration:'350ms',x:'100%'}}"
        >
        </particle-activity-feed>
      </div>
    </div>
    <!-- primary content -->
  </div>
</mat-sidenav-container>

